import { jsx as _jsx } from "react/jsx-runtime";
import { NotesPanel } from '@/shared/components/NotesPanel';
import { useProspectNotes, useAddProspectNote, useDeleteProspectNote } from '../hooks/useProspects';
/**
 * Pestaña "Anotaciones" del detalle de posible alumno: historial fechado de
 * anotaciones privadas del director (prospect_notes). Misma UI compartida
 * (NotesPanel) que la ficha del alumno.
 */
export function ProspectNotesTab({ prospectId }) {
    const { data: notes = [], isLoading, isError } = useProspectNotes(prospectId);
    const addNote = useAddProspectNote(prospectId);
    const deleteNote = useDeleteProspectNote(prospectId);
    return (_jsx(NotesPanel, { notes: notes, isLoading: isLoading, isError: isError, addPending: addNote.isPending, addFailed: addNote.isError, deletePending: deleteNote.isPending, onAdd: (note, opts) => addNote.mutate(note, opts), onDelete: (noteId, opts) => deleteNote.mutate(noteId, opts), placeholder: "Escribe aqu\u00ED una anotaci\u00F3n sobre este posible alumno\u2026" }));
}
//# sourceMappingURL=ProspectNotesTab.js.map